const getCookieValue = (cookieName: string) => {
  const cookie = `; ${document.cookie}`;
  const cookieParts = cookie.split(`; ${cookieName}=`);

  return cookieParts.length === 2 && cookieParts.pop()?.split(';').shift();
};

const setCookieValue = (key: string, value: string, maxAge: number) => {
  if (key && value) {
    document.cookie = `${key}=${value};${
      maxAge && ` max-age=${60 * 60 * 24 * maxAge}`
    }`;

    // check if cookie was successfully set to browser
    return getCookieValue(key) === value;
  }

  return false;
};

export { getCookieValue, setCookieValue };
